import { render, staticRenderFns } from "./MenuUpdate.vue?vue&type=template&id=1cec1b69&"
import script from "./MenuUpdate.vue?vue&type=script&lang=ts&"
export * from "./MenuUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports